import config from 'capacitor.config';

export interface BrowserAppConfig {
  appName: string;
  appId: string;
  version: string;
  distributionVersion: string;
  translationsFilepath: string;
}

export const rMoveAppConfig = {
  appName: config.appName,
  appId: config.appId,
  version: process.env.BROWSER_VERSION,
  distributionVersion: process.env.BROWSER_DISTRIBUTION_VERSION,
  translationsFilepath: 'assets/translations.csv',
} as BrowserAppConfig;
